import styled from "styled-components";

const Container = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    display: flex;
    align-items: end;
    justify-content: space-between;
    padding: 0 48px;
    margin-bottom: 32px;
    height: 64px;
    max-height: 64px;
    background-color: var(--color-White);
`;

function Breadcrumb({ children, ...rest }) {
    return <Container {...rest}>{children}</Container>;
}

export default Breadcrumb;
